<template>
	<div class="lab-entrance">
		<MyModal @close="closeModal" v-if="modal">
			<h4 class="modal-title">
				{{ this.modalContents[this.contentsNum].title }}
			</h4>
			<div class="modal-image">
				<img
					:src="require(`../../assets/img/lab/entrance/${this.contentsNum}.jpg`)"
					:alt="this.modalContents[this.contentsNum].title"
				/>
			</div>
			<div class="modal-comment">
				{{ modalContents[this.contentsNum].comment }}
			</div>
		</MyModal>
		<TypographySvg @openModal="openModal" />
		<div class="banners">
			<router-link to="/newgraduate/lab/special" class="banner_link">
				<div class="banners_item">
					<img src="../../assets/img/lab/entrance/banner.png" alt="スペシャルコンテンツ 研究開発の落とし穴" />
				</div>
			</router-link>
			<router-link to="/newgraduate/lab/staff" class="banner_link">
				<div class="banners_item">
					<div>
						<p>社員紹介</p>
						<KurehaArrow class="kureha_arrow" :width="80" />
					</div>
				</div>
			</router-link>
			<router-link to="/newgraduate/lab/work/" class="banner_link">
				<div class="banners_item">
					<div>
						<p>クレハの仕事</p>
						<KurehaArrow class="kureha_arrow" :width="80" />
					</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
import TypographySvg from '@/components/lab/TypographySvg.vue';
import MyModal from '@/components/MyModal.vue';
import KurehaArrow from '@/components/icons/KurehaArrow.vue';
export default {
	name: 'lab-entrance',
	components: {
		TypographySvg,
		MyModal,
		KurehaArrow,
	},
	data() {
		return {
			modal: false,
			modalContents: [
				{
					title: 'どこにも無ければ、創ればいい。',
					comment:
						'どこにも無ければ、創ればいい。「ナケレバ、ツクレバ。」それがクレハのこだわりであり、クレハの開発精神です。1944年の創業以来、技術開発型企業として自社開発に強いこだわりを持ち、数多くの独創的な製品を創り出してきました。世の中がどんなに変わっても、この精神は変わりません。',
				},
				{
					title: 'BROAD BASE, BUT SPECIALITY.',
					comment:
						'視野は広く、専門性は高く。これが私たちの研究開発のモットーです。ビジネスの発想を「プロダクト・アウト」ではなく「マーケット・イン」を常に意識して、独自の技術とマーケット展開力で「グローバルに事業を展開するスペシャリティ・カンパニー」を実現することで、「エクセレント・カンパニー」を目指します。',
				},
				{
					title: '独自技術のヒストリーこそ、クレハの誇り。',
					comment:
						'技術開発型企業として、私たちが常に誇りに思うこと。それは、外部技術の導入に頼らず、独自の発想で製品を開発し、事業を拡大してきたことです。数々の「世界初」を創り出してきた背景にあるのは、社員一人ひとりのチャレンジ精神。次代を担う製品を生むポテンシャルの高い企業風土を大切に、これからも挑戦を続けます。',
				},
				{
					title: '作る人、食する人、そして大地。',
					comment:
						'クレハが生み出した農業用殺菌剤は、世界中の食糧生産現場において広く使用されています。農薬分野で私たちが大切にしている価値観。それは、作る人、食する人、そして大地、3つの共生を目指すこと。農業の生産性を高めることはもちろん、人にとっても環境にとっても安心・安全な農薬の研究開発に注力しています。',
				},
				{
					title: '社内論文審査制度',
					comment:
						'研究成果の「発表・提案・審査」の過程を共有し、自己実現の場を提供するクレハ独自の文化です。研究に対してのモチベーションを上げ、常に挑戦する風土を醸成しています。また、既存事業を様々な視点から見直し事業発展に貢献してきた論文は、先人たちの経験と知識を吸収できるよき参考書となり、研究開発促進の一助となっています。',
				},
				{
					title: 'クレハカット',
					comment:
						'お客さまの声に徹底的に耳を傾け、改良を続けているNEW クレラップ。そのひとつが、箱を持つ手を内側にクルッと回転させるだけで、ラップを真ん中からスパッと切れるV字型の刃です。ラップがまとわりついたり巻き戻ったりするストレスから解放する独自のラップの切り方を、クレハカットと名付けました。',
				},
				{
					title: 'NEWクレラップ',
					comment:
						'1951年に開発した塩化ビニリデン樹脂・クレハロンの用途を拡大するために日夜研究を重ね、ついに全く臭わない無臭フィルムの製造に成功。これが、1960年に日本で最初の家庭用ラップとして発売した「クレラップ」につながったのです。その後も何度も改良を重ね、1989年には「NEWクレラップ」として生まれ変わりました。',
				},
				{
					title: 'クレハロン',
					comment:
						'クレハロンは、1951年に独自技術により生み出した塩化ビニリデン樹脂。特に私たちが注目したのは、その抜群のガスバリア性でした。そこで、魚肉ソーセージなどの食品包装分野が最も適した用途である考え、クレハロンのフィルム開発に注力。現在でも主力製品のひとつとして、世界中で活躍しています。',
				},
				{
					title: '中央研究棟',
					comment:
						'2015年に福島県のいわき事業所内に完成した中央研究棟は、プロセス開発、有機合成、分析評価などの機能を備える研究開発施設。研究者の交流と協業を促すため、居室はワンフロア化、実験室は大部屋化されています。自由な情報交換の場として、コミュニケーションスペースも設けられています。',
				},
				{
					title: '世界初のフロロカーボン',
					comment:
						'釣糸のトップブランドとして支持されている「シーガー」は、世界で初めてフロロカーボン（フッ化ビニリデン樹脂）を素材とする釣糸として、クレハが1971年に開発・発売しました。原料となるKFポリマーは当社いわき事業所で生産。自社原料を用いてフロロカーボン製釣糸の製品開発を行うことができるのは世界でもクレハグループだけです。',
				},
				{
					title: '世界初のPGA大量生産',
					comment:
						'高い強度と優れた生分解性を持つＰＧＡ（ポリグリコール酸）樹脂。クレハ独自の技術で世界初の量産化に成功し、「Kuredux®」の商標で商品化されました。現在はシェールオイル・ガスの掘削現場で使用される分解性フラックプラグ（KDP：Kureha Degradable Plug)として、シェール産業の拡大に寄与しています。',
				},
				{
					title: '塩化ビニリデンモノマー置き忘れ事件',
					comment:
						'当時、塩化ビニリデンモノマーの重合は非常に難航し、疲れた研究員は、分離状態のモノマーを三角フラスコに入れたまま置き忘れて帰りました。しかし、翌日来てみると、フラスコの中の塩化ビニリデンモノマーは見事に懸濁重合に成功していたのです。この偶然の出来事から、塩化ビニリデンの生産技術が確立。クレハロンと名づけられ、本格的に市場獲得に乗り出しました。',
				},
				{
					title: '少数精鋭',
					comment:
						'国内外のお客様から高い信頼を得るクレハですが、スタンスはあくまで少数精鋭。一人ひとりが自分の仕事に誇りと責任を持って働けるよう、若いうちから責任の大きな仕事を任せることもあります。社員のやる気とチャレンジ精神を何よりも尊重することで、世の中にない新しい価値を生み出し続けています。',
				},
				{
					title: 'ピエゾフィルム',
					comment:
						'KFピエゾフィルムは、クレハが世界で初めて工業化に成功した高分子強誘電材料。フィルムの分子構造により顕著な圧電・焦電性を示す、ユニークな材料です。スピーカーや各種センサー等に使用され、JAXAの宇宙帆船「イカロス」のスペースダストセンサーにも搭載されました。',
				},
				{
					title: 'KFポリマー',
					comment:
						'クレハKFポリマーは、1970年にクレハが日本で最初に工業生産を開始したフッ化ビニリデン樹脂（PVDF）。フッ素樹脂としての優れた性質と汎用樹脂並みの成形加工性を持つ、バランスのとれたエンジニアリング・プラスチックです。リチウムイオン電池の電極用バインダーや水処理膜など、先端技術分野にも用途が拡大しています。',
				},
				{
					title: 'PGA（ポリグリコール酸）樹脂',
					comment:
						'クレハが世界で初めて量産化に成功したPGA（ポリグリコール酸）樹脂「Kuredux®」。開発がスタートした当初は実験室の片隅で行われていた基礎研究がどんどん進展し、米国にプラントを立ち上げ、2012年に商業生産を開始。現在では幅広い分野での市場開発が世界中で進んでおり、クレハの将来を担う事業のひとつになりました。',
				},
				{
					title: '「技術立社」',
					comment:
						'私たちは自社開発をDNAに持つ企業として、クレハにしかつくれないモノ、できないコトに挑戦してきました。そして、その思いはこれからも変わりません。既存事業の成長はもちろん、新規事業の創出にも力を入れ、差別化された製品の開発によって社会に貢献し続ける「高付加価値型企業」となることを目指します。',
				},
				{
					title: 'プロセスエンジニアリング',
					comment:
						'ラボで開発された製品をプラントスケールで実際に量産化していくためには、合理的な製造プロセスの開発と設計が欠かせません。その過程では、反応収率、原料コストや廃棄物量、安全性や操作性など多角的な視点が必要不可欠。クレハは優れたプロセスエンジニアリング技術で、世界初の製品を数多く生み出してきました。',
				},
				{
					title: '「この塩素を何かに利用できないか」',
					comment:
						'戦後の荒廃の中、クレハが最初に軌道にのせた事業はか性ソーダの生産でした。その過程で併産される塩素。私たちは「この塩素を何かに利用できないか」と考え、大量に発生する塩素の有効利用を模索しました。様々な研究の結果、塩化ビニリデン樹脂「クレハロン」が誕生しました。「クレハロン」はチルド輸送網が未整備な時代において、食糧問題へ貢献してきました。',
				},
				{
					title: 'クレハマイクロスフェアー',
					comment:
						'クレハマイクロスフェアーは、クレハが独自技術で開発した熱膨張性マイクロカプセルです。加熱により急激に膨張（＝発泡）する特性を持ち、自動車部品、樹脂性靴底、発泡インキ、壁紙、粘着剤など幅広い用途に応用されています。',
				},
				{
					title: 'クレハグローバルネットワーク',
					comment:
						'クレハは現在、アメリカ、ヨーロッパ、アジア、オセアニアの各地域に拠点を持ち、着実に市場を広げています。マーケットの広がりに伴って海外での生産も拡大しており、海外拠点の駐在スタッフとして活躍する社員や海外市場開拓をミッションに掲げる社員も大勢います。',
				},
				{
					title: 'ものづくり日本大賞経済産業大臣賞受賞',
					comment:
						'クレハが行ってきた独自の研究開発は、これまで数々の賞を受賞してきました。中でも、環境負荷低減を実現する高機能型生分解性樹脂ポリグリコール酸（ＰＧＡ）の開発は、世界で初めて量産化に成功した功績が認められ「第5回ものづくり日本大賞 製品・技術開発部門」で経済産業大臣賞を受賞しました。',
				},
				{
					title: '技術開発に年功序列は関係ない',
					comment:
						'技術開発に必要なことは、既存の価値観に縛られることなく自由な発想でイノベーションを起こそうとする探究心と実行力だと考えます。そのためクレハでは、若手社員の意見にもしっかりと耳を傾け、入社年次に関係なくやりたいことにチャレンジできる環境づくりに力を入れています。',
				},
				{
					title: 'フォートロンKPS',
					comment:
						'ポリフェニレンサルファイド（PPS）は、機械強度、耐熱性、耐薬品性、難燃性に優れた高機能プラスチック。1987年、クレハは独自に開発した直鎖状のPPS樹脂フォートロンKPSの生産を開始しました。現在は福島県のいわき事業所と米国ノースカロライナ州のFortron Industriesで生産され、その性能は世界中で高く評価されています。',
				},
				{
					title: 'メトコナゾール',
					comment:
						'クレハが発明したトリアゾール系の農業・園芸用殺菌剤。麦類やトウモロコシの重要病害に卓効を示し、現在では世界40か国以上で農薬登録を取得しています。メトコナゾールの開発は国内で複数の賞を受賞するなど、その功績は高く評価されています。',
				},
				{
					title: 'イプコナゾール',
					comment:
						'播種前の種子の消毒に用いる種子消毒剤。種子伝染性や土壌伝染性の病害に対し、低薬量で高い防除効果を示します。種子消毒は、環境負荷の少なさから世界中で注目を集める処理方法。国内では同分野でトップシェアを有し、海外においては欧州、北米、中南米、アジアでの販売が行われています。',
				},
			],
		};
	},
	methods: {
		openModal(el) {
			this.modal = true;
			// console.log(el);
			// console.log(el.target.parentElement.getAttribute('data-num'));
			// this.contentsNum = el.target.parentElement.getAttribute('data-num');
			// this.contentsNum = el.parentNode.dataset.num;
			this.contentsNum = el.target.parentNode.getAttribute('data-num');
		},
		closeModal() {
			this.modal = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.lab-entrance {
	background-image: radial-gradient(circle at 40% 120%, #3fae00 -20%, transparent 40%),
		radial-gradient(circle at 70% 130%, #3fae00 -20%, transparent 40%),
		radial-gradient(circle at top right, #3fae00 -40%, transparent 40%);
	background-size: 100%;
	background-color: #00797f;
	padding-bottom: 50px;
	@media print, screen and (max-width: 900px) {
		margin-bottom: 17vw;
	}
	@media print, screen and (max-width: 768px) {
		padding-bottom: 100px;
	}
	&:before {
		content: '';
		width: 100%;
		height: 100%;
		display: block;
		position: absolute;
		top: 0;
		background-image: linear-gradient(#cccccc54 1px, transparent 0), linear-gradient(90deg, #cccccc54 1px, transparent 0);
		background-size: 10px 10px;
		z-index: 0;
	}
}
::v-deep .modal.modal-overlay {
	background: rgba(0, 0, 0, 0.8);
}
::v-deep .modal-window {
	background-color: transparent;
}
::v-deep .close_button {
	height: 70px;
	.close_button_inner {
		background-image: url('../../assets/img/lab/entrance/close.svg');
		height: 50px;
		width: 50px;
	}
}
.modal-title {
	color: #fff;
	font-size: 28px;
	margin: 0;
}
.modal-comment {
	color: #fff;
	font-weight: bold;
}
.banner_link {
	display: block;
	position: fixed;
  bottom: 0;
	//bottom: 40px;
	width: 100%;
	height: 90px;
	z-index: 1;
	@media print, screen and (max-width: 900px) {
		// bottom: 80px;
		bottom: 0;
		&:nth-child(1) {
			height: 19vw;
			min-height: 75px;
		}
		&:nth-child(n + 2) {
			height: 17vw;
			min-height: 60px;
			max-height: 90px;
		}
	}
	@media (hover: hover) {
		transition: all 0.2s ease-out;
		&:hover {
			opacity: 1 !important;
			background-color: #545454 !important;
		}
	}
}
.banners {
	.banner_link {
		& + & {
			margin-left: 5px;
		}
		&:nth-child(1) {
			background-color: #3fae00;
			width: 60%;
			left: 0;
			@media print, screen and (min-width: 901px) and (max-width: 1200px) {
				width: 56%;
			}
			@media print, screen and (max-width: 900px) {
				width: 100%;
			}
			.banners_item {
				transition: background-color 0.2s;
				text-align: center;
			}
			img {
				transition: transform 0.1s;
				vertical-align: bottom;
				width: 90%;
				@media print, screen and (min-width: 901px) {
					transform: translateY(-15%);
					max-width: 660px;
				}
				@media print, screen and (max-width: 900px) {
					transform: translateY(25%);
					max-width: 900px;
				}
			}
			&:hover {
				img {
					transform: translateY(-10%);
					@media print, screen and (max-width: 900px) {
						transform: translateY(35%);
					}
				}
			}
		}
		&:nth-child(n + 2) {
			display: flex;
			justify-content: center;
			align-items: center;
			algin-content: center;
			background-color: #fff000;
			.banners_item {
				color: #00797f;
				width: 100%;
				&::before {
					display: inline-block;
					content: '';
					position: absolute;
					z-index: 1;
					background-size: contain;
					background-repeat: no-repeat;
				}
				& > div {
					position: relative;
					box-sizing: border-box;
					margin: 0 auto;
					font-size: 26px;
					width: 220px;
					max-width: 90%;
					@media print, screen and (min-width: 901px) and (max-width: 1200px) {
						font-size: 23px;
						width: 190px;
					}
					@media print, screen and (max-width: 597px) {
						font-size: 4.5vw;
						max-width: 80%;
						width: 200px;
					}
					p {
						font-weight: bold;
						margin: 0 auto;
						display: inline-block;
					}
					.kureha_arrow {
						position: absolute;
						width: 60px;
						height: 11px;
						left: auto;
						right: 0;
						top: 49%;
						box-sizing: border-box;
						margin-right: -0.2em;
						@media print, screen and (min-width: 901px) and (max-width: 1200px) {
							width: 50px;
							height: 9px;
						}
						@media print, screen and (max-width: 597px) {
							width: 10vw;
							max-width: 40px;
							height: 1.9vw;
							max-height: 8px;
						}
					}
				}
			}
		}
		// 社員紹介
		&:nth-child(2) {
			// background-color: #00797f;
			width: calc(20% - 5px);
			left: calc(60% + 5px);
			@media print, screen and (min-width: 901px) and (max-width: 1200px) {
				width: calc(22% - 5px);
				left: calc(56% + 5px);
			}
			@media print, screen and (max-width: 900px) {
				width: calc(50% - 5px);
				left: 0;
				bottom: calc(19vw);
			}
			.banners_item::before {
				content: '';
				top: -64px;
				left: 50%;
				transform: translate(-50%, 10%);
				width: 152px;
				height: 65px;
				background-image: url('../../assets/img/kurehaTest/obj01.png');
				pointer-events: none;
				opacity: 0;
				@media print, screen and (max-width: 900px) {
					content: none;
				}
			}
			@media (hover: hover) {
				&:hover {
					.banners_item::before {
						transition: all 0.2s ease-out;
						background-image: url('../../assets/img/kurehaTest/obj01_gray.png');
						opacity: 1;
						transform: translate(-50%, 0);
					}
				}
			}
		}
		// クレハの仕事
		&:nth-child(3) {
			// background-color: #005860;
			width: calc(20% - 5px);
			right: 0;
			@media print, screen and (min-width: 901px) and (max-width: 1200px) {
				width: calc(22% - 5px);
			}
			@media print, screen and (max-width: 900px) {
				width: calc(50% - 5px);
				bottom: calc(19vw);
			}
			.banners_item {
				div:nth-child(1) {
					p {
						margin-left: -0.2em !important;
					}
				}
			}
			.banners_item::before {
				content: '';
				top: -64px;
				left: 50%;
				transform: translate(-50%, 10%);
				width: 72px;
				height: 65px;
				background-image: url('../../assets/img/kurehaTest/obj02.png');
				opacity: 0;
				pointer-events: none;
				@media print, screen and (max-width: 900px) {
					content: none;
				}
			}
			@media (hover: hover) {
				&:hover {
					.banners_item::before {
						transition: all 0.2s ease-out;
						background-image: url('../../assets/img/kurehaTest/obj02_gray.png');
						opacity: 1;
						transform: translate(-50%, 0);
					}
				}
			}
		}
	}
}
</style>
